import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CompletionComponent } from './completion.component';
import { CanActivateSessionGuard } from '../services/can-activate-session-guard.service';

const routes: Routes = [
    {
        path: 'completion',
        component: CompletionComponent,
        canActivate: [
            CanActivateSessionGuard
        ]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class CompletionRoutingModule { }